import React from 'react'
import PropTypes from 'prop-types'
import styles from './MoonAtsActivityOverview.module.scss'
import Locale from '../Locale'
import Flexgrid from '../Flexgrid'
import { checkNegative } from '../../utils/locale'
import moment from 'moment-timezone'

const MoonAtsActivityOverview = ({ info = [], layouts, date, hideTime }) => {
  if (!info.length) return null

  const formattedDate = date
    ? moment(date).tz('America/New_York').format(hideTime ? 'MM/DD/YYYY' : 'MM/DD/YYYY hh:mm a')
    : null

  return (
    <div className={styles.MoonAtsActivityOverview}>
      <Flexgrid className={styles.marketInfo} layouts={layouts}>
        {info.map(({ key, title, value }) => (
          <div className={styles.marketItem} key={key}>
            <div>{title}</div>
            <p>{checkNegative(value) === 'N/A' ? 'N/A' : <Locale type='int'>{value}</Locale>}</p>
          </div>
        ))}
      </Flexgrid>
      {formattedDate && <abbr>{formattedDate}</abbr>}
    </div>
  )
}

MoonAtsActivityOverview.propTypes = {
  /** Selected market data */
  info: PropTypes.arrayOf(
    PropTypes.shape({
      /** Key of the item */
      key: PropTypes.string.isRequired,
      /** Title of the item */
      title: PropTypes.string.isRequired,
      /** Value of the item */
      value: PropTypes.number.isRequired
    })
  ),
  /** Layout to pass to Flexgrid */
  layouts: PropTypes.object.isRequired,
  /** Date & time the market data was received */
  date: PropTypes.number,
  hideTime: PropTypes.bool
}

export default MoonAtsActivityOverview